import * as React from 'react';
import { ExpansionPanel, ExpansionPanelSummary, Typography, ExpansionPanelDetails, withStyles, Theme, WithStyles, CircularProgress, Button, List, ListItem, ListItemText, Divider, createStyles } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { SubAccount, UsersAPI, errorToString, DatasourcesAPI } from 'src/api';
import strings from 'src/strings';
import { withToast, WithToast } from '../HOC/Toast';
import { DataSourceType, DataSource as DS } from 'src/api/models/datasource';
import FacebookLogin, { ReactFacebookLoginInfo } from 'react-facebook-login';
import { SubPage } from 'src/api/endpoints/datasources';

interface ConnectDataSourceProps extends WithStyles<typeof styles>, WithToast {
    className?: string;
    client: SubAccount
}
class ExtendedDatasource extends DS {
    sub_accounts?: SubPage[]
}
interface ConnectDataSourceState {
    loading_states: {
        [key in DataSourceType]: boolean
    },
    change_state: {
        [key in DataSourceType]?: string
    }
    sources: ExtendedDatasource[]
    client: SubAccount
}
class ConnectDataSource extends React.Component<ConnectDataSourceProps, ConnectDataSourceState> {

    constructor(props: ConnectDataSourceProps) {
        super(props);
        this.state = {
            loading_states: {
                google_adwords: true,
                google_analytics: true,
                facebook: true,
            },
            client: this.props.client,
            change_state: {

            },
            sources: []
        }
        this.facebookeResponse = this.facebookeResponse.bind(this)
    }


    componentWillReceiveProps(nextProps: ConnectDataSourceProps) {
        if (nextProps.client.id != this.props.client.id) {
            this.setState({ client: nextProps.client })
        }
    }

    private changeLoadingState(key: DataSourceType, loading: boolean) {
        let states = this.state.loading_states;
        states[key] = loading
        return states
    }

    private facebookeResponse(response: ReactFacebookLoginInfo) {
        return UsersAPI.addDatasource(response.accessToken, DataSourceType.FACEBOOK).then(source => {
        })
    }

    componentDidMount() {
        UsersAPI.getDatasources().then(sources => {
            Object.keys(DataSourceType).forEach(key => {
                let type = DataSourceType[key];
                let source = sources.find(t => t.type == type)
                if (source) {
                    const load = () => {
                        DatasourcesAPI.getSubAccounts(source!).then((accounts) => {
                            (source as ExtendedDatasource).sub_accounts = accounts
                            this.setState({ loading_states: this.changeLoadingState(source!.type, false), sources: this.state.sources.concat(source!) })
                        }).catch(err => {
                            errorToString(err).forEach(error => {
                                this.props.showToast('error', error)
                            })
                            this.setState({ loading_states: this.changeLoadingState(source!.type, false) })
                        })
                    }
                    load()
                } else {
                    this.setState({ loading_states: this.changeLoadingState(type, false) })
                }
            })
        }).catch(err => {
            errorToString(err).forEach(error => {
                this.props.showToast('error', error)
            })
            this.setState({ loading_states: { google_adwords: false, google_analytics: false, facebook: false } })
        });
    }

    private selectedAccount(type: DataSourceType, id: string) {
        return this.state.client.datasources.find(t => t.datasource.type == type && t.page_id == id)
    }

    private textForDatasourceType(type: DataSourceType) {
        switch (type) {
            case DataSourceType.GOOGLE_ADWORDS: {
                return {
                    title: strings.googleAdwords,
                    description: strings.datasource_connectGoogleAdwordsView
                }
            }
            case DataSourceType.GOOGLE_ANALYTICS: {
                return {
                    title: strings.googleAnalytics,
                    description: strings.datasource_connectGoogleAnalyticsView
                }
            }
            case DataSourceType.FACEBOOK: {
                return {
                    title: strings.facebook,
                    description: strings.datasource_connectFacebookPage
                }
            }
        }
    }

    private setClientDatasource(type: DataSourceType) {
        let new_id = this.state.change_state[type];
        if (new_id) {
            if (!this.selectedAccount(type, new_id)) {
                this.setState({ loading_states: this.changeLoadingState(type, true) })
                DatasourcesAPI.setClientDatasource(this.state.sources.find(t => t.type == type)!, new_id, this.state.client).then((client) => {
                    let changesets = this.state.change_state
                    changesets[type] = undefined
                    this.setState({ loading_states: this.changeLoadingState(type, false), client, change_state: changesets })
                }).catch(err => {
                    errorToString(err).forEach(error => {
                        this.props.showToast('error', error)
                    })
                    this.setState({ loading_states: this.changeLoadingState(type, false) })
                });
            }
        }
    }

    public render() {
        const { classes } = this.props
        const types = Object.keys(DataSourceType)
        return <div className={this.props.className} style={{ paddingBottom: '10px' }}>
            {types.map((type: DataSourceType) => {
                let type_name = DataSourceType[type]
                return <ExpansionPanel key={type_name} disabled={this.state.sources.find(s => s.type == type_name) == undefined}>
                    <ExpansionPanelSummary expandIcon={this.state.loading_states[type_name] ? <CircularProgress size={20} /> : <ExpandMoreIcon />}>
                        <Typography className={classes.heading}>
                            {this.textForDatasourceType(type_name).title}
                            {this.state.sources.find(s => s.type == type_name) == undefined && !this.state.loading_states[type_name] &&
                                <Typography className={this.props.classes.headingNotice}>
                                    ({strings.datasource_connectInSettings})
                            </Typography>}
                        </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails style={{ display: 'block' }}>
                        <Typography variant='subtitle2'>
                            {this.textForDatasourceType(type_name).description}
                        </Typography>
                        {this.state.sources.find(s => s.type == type_name) && <List>
                            {(this.state.sources.find(s => s.type == type_name)!.sub_accounts || []).map(account => {
                                return <>
                                    <ListItem button key={account.id} disabled={this.state.loading_states[type_name]} onClick={() => {
                                        if (!this.selectedAccount(type_name, account.id)) {
                                            let states = this.state.change_state
                                            states[type_name] = account.id
                                            this.setState({ change_state: states })
                                        } else {
                                            let states = this.state.change_state
                                            states[type_name] = undefined
                                            this.setState({ change_state: states })
                                        }
                                    }} selected={this.state.change_state[type_name] ? this.state.change_state[type_name] == account.id : this.selectedAccount(type_name, account.id) != undefined}>
                                        <ListItemText>{account.name}</ListItemText>
                                    </ListItem>
                                    <Divider />
                                </>
                            })}
                        </List>}
                        {this.state.change_state[type_name] && <Button disabled={this.state.loading_states[type_name]} className={this.props.classes.saveButton} onClick={(e) => {
                            this.setClientDatasource(type_name)
                        }} variant='contained' color='primary'>
                            {strings.save}
                        </Button>}
                    </ExpansionPanelDetails>
                </ExpansionPanel>
            })}
        </div>
    }
}

const styles = (theme: Theme) => createStyles({
    root: {
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular
    },
    headingNotice: {
        fontSize: theme.typography.pxToRem(13),
    },
    saveButton: {
        float: 'right',
        marginBottom: theme.spacing(2)
    }
});

export default withToast(withStyles(styles)(ConnectDataSource))


// WEBPACK FOOTER //
// ./src/components/Client/ConnectDatasource.tsx